import { IMassCreativeCreateMessage, IMsrkMessage, IScreenshotMessage, NotificationMessage, NotificationMessages, TMessage } from "domains/notification/types";
import { TFunction } from "react-i18next";
import { SpringValue } from "react-spring";
import { Position } from "../hooks/useAnchorPosition";

export interface INotificationPanelData {
  t: TFunction<'translation'>;
  notificationMessages: NotificationMessages | null;
  open: boolean;
  setOpen: (open: boolean) => void;
  buttonRef: React.RefObject<HTMLDivElement>;
  openTaskModal: boolean;
  setOpenTaskModal: React.Dispatch<React.SetStateAction<boolean>>;
  unreadCount: number;
  markAllAsRead: () => void;
  markAsRead: (id: number) => void;
  markAsReadAndRemove: (id: number) => void;
  handleGetTask: (task_id: number) => void;
}

export interface IUsePanelData {
  t: TFunction<'translation'>;
  panelRef: React.RefObject<HTMLDivElement>;
  position: Position | null;
  animation: {
    opacity: SpringValue<number>;
    transform: SpringValue<string>;
  };
  filteredNotifications: IFormattedNotification[];
  selectedTab: number;
  setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
}

export interface IUsePanelProps {
  anchorRef: React.RefObject<HTMLDivElement>;
  open: boolean;
  onClose: () => void;
  buttonRef: React.RefObject<HTMLDivElement>;
  notificationsList: IFormattedNotification[];
}

export interface IUseNotificationItemData {
  style: {
    x: SpringValue<number>;
    opacity: SpringValue<number>;
  };
  handleMarkAsRead: () => void;
}

export interface IUseNotificationItemProps {
  markAsRead: (id: number) => void;
  markAsReadAndRemove: (id: number) => void;
  notification_id: number;
  is_read: boolean;
}

export interface IUseScreenshotNotificationData {
  creative_xxhash: string | undefined;
  creative_internal_id: string | undefined;
  creative_title: string | undefined;
  screenshot_url: string | undefined;
  campaign_xxhash: string | undefined;
  loadedImg: boolean;
  setLoadedImg: React.Dispatch<React.SetStateAction<boolean>>;
  saveScreenHandler: () => void;
}

export interface IUseScreenshotNotificationProps {
  message: TMessage;
  handleMarkAsRead: () => void;
}

export type TTypeNotification = 'screenshot' | 'batchdownload' | 'campaignperiod';

export type TScreenshotType = NotificationMessage & IScreenshotMessage & {
  text: JSX.Element;
}

export type TBatchdownloadType = NotificationMessage & IMassCreativeCreateMessage & {
  text: JSX.Element;
};

export type TMarkType = NotificationMessage & IMsrkMessage & {
  text: JSX.Element;
};

// export type TCampaignperiodType = NotificationMessage & {
//   type: 'campaignperiod';
//   text: JSX.Element;
// };

export type IFormattedNotification = Omit<NotificationMessage, 'text'> & {
  text: JSX.Element;
};

export function isScreenshotTypeHasData(data: IFormattedNotification): data is TScreenshotType {
  return data && 'creative_xxhash' in data.message && 'creative_title' in data.message;
}

export function isMassCreativeCreateTypeHasData(data: IFormattedNotification): data is TBatchdownloadType {
  return data && 'campaign_xxhash' in data.message && 'campaign_title' in data.message && 'campaign_title' in data.message;
}

export function isMarkTypeHasData(data: IFormattedNotification): data is TMarkType {
  return data && 'creative_xxhash' in data.message && 'creative_title' in data.message && 'campaign_xxhash' in data.message;
}